import { createBrowserRouter, RouterProvider } from 'react-router'

import { RouteErrorBoundary } from '@/shared/components/route-error-boundary'

const router = createBrowserRouter([
  {
    path: '/login',
    lazy: () =>
      import('@/features/auth/components/login-page').then((module) => ({
        Component: module.LoginPage,
      })),
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: '/register',
    lazy: () =>
      import('@/features/auth/components/register-page').then((module) => ({
        Component: module.RegisterPage,
      })),
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: '/forgot-password',
    lazy: () =>
      import('@/features/auth/components/forgot-password-page').then((module) => ({
        Component: module.ForgotPasswordPage,
      })),
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: '/reset-password',
    lazy: () =>
      import('@/features/auth/components/reset-password-page').then((module) => ({
        Component: module.ResetPasswordPage,
      })),
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: '/verify-email',
    lazy: () =>
      import('@/features/auth/components/verify-email-page').then((module) => ({
        Component: module.VerifyEmailPage,
      })),
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: '/',
    lazy: () =>
      import('@/app/routes/app-shell').then((module) => ({
        Component: module.AuthenticatedAppShell,
      })),
    errorElement: <RouteErrorBoundary />,
    children: [
      {
        index: true,
        lazy: () =>
          import('@/features/platform/components/status-page').then((module) => ({
            Component: module.StatusPage,
          })),
      },
      {
        path: 'settings',
        lazy: () =>
          import('@/features/settings/components/settings-page').then((module) => ({
            Component: module.SettingsPage,
          })),
      },
      {
        path: '*',
        lazy: () =>
          import('@/app/routes/not-found').then((module) => ({
            Component: module.NotFoundPage,
          })),
      },
    ],
  },
])

export function AppRouter() {
  return <RouterProvider router={router} />
}
